import mainStyle from "../clients.module.scss";

import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import CollapseCard from "components/Collapse";

const GeneralContent = ({
  isWired,
  selectedClient,
  selectedSiteId
}) => {
  const theme = useTheme();
  const title = isWired ? 'Wired' : 'Wireless';
  const readOnlyStyle = {
    color: theme.palette.primary.greyPrimary,
    fontSize: theme.typography.customFontSize[2],
    fontWeight: theme.typography.customFontWeight[1],
  };
  const dashStyle = {
    margin: '0 8px',
  };
  const underlineStyle = {
    borderBottom: `1px solid ${theme.palette.primary.greyPrimary}`,
    paddingBottom: '4px',
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        p: 4,
        boxSizing: "border-box",
        gap: "20px",
      }}
    >
      <CollapseCard title={title} >
        <Box className={mainStyle["section-container"]}>
          {/* Connected to */}
          <Box>
            <Box className={mainStyle["row-style"]}>
              <Typography className={mainStyle["collapse-typography"]}>
                Connected to
              </Typography>
              <Typography sx={readOnlyStyle}>
                <Box component="span" sx={underlineStyle}>
                  {selectedClient.connectedToDeviceName}
                </Box>
              </Typography>
            </Box>
          </Box>
          {/* IP Address */}
          <Box>
            <Box className={mainStyle["row-style"]}>
              <Typography className={mainStyle["collapse-typography"]}>
                IP Address
              </Typography>
              <Typography sx={readOnlyStyle}>
                {selectedClient.ipAddress || '-'}
              </Typography>
            </Box>
          </Box>
          {/* Interface */}
          <Box>
            <Box className={mainStyle["row-style"]}>
              <Typography className={mainStyle["collapse-typography"]}>
                Interface
              </Typography>
              <Typography sx={readOnlyStyle}>
                {selectedClient.formattedInterface}
              </Typography>
            </Box>
          </Box>
          {/* VLAN */}
          <Box>
            <Box className={mainStyle["row-style"]}>
              <Typography className={mainStyle["collapse-typography"]}>
                VLAN
              </Typography>
              <Typography sx={readOnlyStyle}>
                {selectedClient.vlan}
              </Typography>
            </Box>
          </Box>
          {/* Wireless Network */}
          {/* {
            !isWired && (
              <>
                <Box>
                  <Box className={mainStyle["row-style"]}>
                    <Typography className={mainStyle["collapse-typography"]}>
                      Wireless Network
                    </Typography>
                    <Typography sx={readOnlyStyle}>
                      {selectedClient.ssid}
                    </Typography>
                  </Box>
                </Box>
              </>
            )
          } */}
          {/* Channel */}
          {
            !isWired && (
              <>
                <Box>
                  <Box className={mainStyle["row-style"]}>
                    <Typography className={mainStyle["collapse-typography"]}>
                      Channel
                    </Typography>
                    <Typography sx={readOnlyStyle}>
                      {selectedClient.channel}/{selectedClient.band}
                    </Typography>
                  </Box>
                </Box>
              </>
            )
          }
          {/* SNR */}
          {
            !isWired &&
            <Box>
              <Box className={mainStyle["row-style"]}>
                <Typography className={mainStyle["collapse-typography"]}>
                  SNR
                </Typography>
                <Typography sx={readOnlyStyle}>
                  {selectedClient.snr ? `${selectedClient.snr}dB` : '-'}
                </Typography>
              </Box>
            </Box>
          }
          {/* Manufacturer */}
          <Box>
            <Box className={mainStyle["row-style"]}>
              <Typography className={mainStyle["collapse-typography"]}>
                Manufacturer
              </Typography>
              <Typography sx={readOnlyStyle}>
                {selectedClient.manufacturer || '-'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CollapseCard >
    </Box >
  );
};

export default GeneralContent;
